export const GET_APPLICATION_LIST = 'GET_APPLICATION_LIST'
export const GET_RECIPIENTS_LIST = 'GET_RECIPIENTS_LIST'

export const MAKE_BATCH_CALL = 'MAKE_BATCH_CALL'

export const MAKE_RESEND_EMAIL = 'MAKE_RESEND_EMAIL'
